var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftUserWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 3.5H2.625C2.14175 3.5 1.75 3.89175 1.75 4.375V5.54167C1.75 6.02492 2.14175 6.41667 2.625 6.41667H4.375H9.625H11.375C11.8582 6.41667 12.25 6.02492 12.25 5.54167V4.375C12.25 3.89175 11.8582 3.5 11.375 3.5Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.62499C7 1.81957 7.65292 1.16666 8.45833 1.16666H8.75C9.39433 1.16666 9.91667 1.68899 9.91667 2.33332V2.33332C9.91667 2.97766 9.39433 3.49999 8.75 3.49999H7V2.62499Z",
    stroke: "#E6E6E6",
    strokeWidth: 0.875
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.62499C7 1.81957 6.34708 1.16666 5.54167 1.16666H5.25C4.60567 1.16666 4.08333 1.68899 4.08333 2.33332V2.33332C4.08333 2.97766 4.60567 3.49999 5.25 3.49999H7V2.62499Z",
    stroke: "#E6E6E6",
    strokeWidth: 0.875
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33334 7.29166V10.5C2.33334 11.7887 3.378 12.8333 4.66667 12.8333H6.53334L6.53334 7.29166H2.33334ZM7.40834 7.29166L7.40834 12.8333H9.33334C10.622 12.8333 11.6667 11.7887 11.6667 10.5V7.29166H7.40834Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftUserWhite);
export default __webpack_public_path__ + "static/media/gift-user-white.89fc6394fd77c9d3212bc5f823824d9d.svg";
export { ForwardRef as ReactComponent };